<template>
  <header class="searchHeader">
    <h1 v-if="title"><span class="word">{{ title }}</span></h1>
    <h1 v-else>検索結果</h1>
    <div class="found">
      <p class="count"><span class="num">{{ total }}</span>件</p>
    </div>
    <div class="filters">
      <form class="actions" :action="link.search">
        <div class="icon"></div>
        <div class="chip selectable sort" :class="{ 'selected': filters.sort_by !== null }" @click.self="togglePopup('sort')">
          並べ替え
          <div class="popup" v-if="popup === 'sort'">
            <div class="content" v-click-outside="onClickOutside">
              <h2 class="title">並べ替え</h2>
              <label>
                <input type="radio" name="sort_by" v-model="filters.sort_by" value="new">
                新着順
              </label>
              <label>
                <input type="radio" name="sort_by" v-model="filters.sort_by" value="old">
                古い順
              </label>
              <label>
                <input type="radio" name="sort_by" v-model="filters.sort_by" value="like">
                お気に入りが多い順
              </label>
              <div class="button" @click.stop="search()">適用する</div>
            </div>
          </div>
        </div>
        <div class="chip selectable genre" :class="{ 'selected': filters.genre.length !== 0 }" @click.self="togglePopup('genre')">
          ジャンル
          <div class="popup" v-if="popup === 'genre'">
            <div class="content" v-click-outside="onClickOutside">
              <h2 class="title"> ジャンル </h2>
              <label v-for="genre in genres">
                <input type="checkbox" name="genre" v-model="filters.genre" :value="genre.id">
                {{ genre.name }}
              </label>
              <div class="button" @click.stop="search()"> 適用する</div>
            </div>
          </div>
        </div>
        <div class="chip selectable area" :class="{ 'selected': filters.area !== null }" @click.self="togglePopup('area')">
          エリア
          <div class="popup" v-if="popup === 'area'">
            <div class="content" v-click-outside="onClickOutside">
              <h2 class="title"> エリア </h2>
              <label v-for="area in areas">
                <input type="radio" name="area" v-model="filters.area" :value="area.id">
                {{ area.name_public }}
              </label>
              <div class="button" @click.stop="search()"> 適用する</div>
            </div>
          </div>
        </div>
        <div class="clear" @click.stop="clear()">クリア</div>
      </form>
    </div>
  </header>
</template>
<script>
import vClickOutside from 'click-outside-vue3'

export default {
  props: {
    title: {
      type: String,
      required: false
    },
    total: {
      type: Number,
      required: true
    },
    params: {
      type: Object,
      required: false
    },
    link: {
      type: String,
      required: true
    },
    genres: {
      type: Array,
      required: true,
    },
    tags: {
      type: Array,
      required: false,
    },
    areas: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      filters: {
        sort_by: 'new',
        genre: [],
        area: null
      },
      popup: null,
      filtersComparison: {},
    }
  },
  mounted() {
    this.setParam()
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  methods: {
    onClickOutside() {
      this.popup = null
      if (JSON.stringify(this.filters) !== JSON.stringify(this.filtersComparison)) {
        this.search()
      }
    },
    togglePopup(filter) {
      this.popup = this.popup === filter ? null : filter
    },
    clear() {
      this.filters = {
        sort_by: 'new',
        genre: [],
        area: null
      }
      window.location.href = this.link
    },
    search() {
      const url = new URL(this.link)
      if (Object.keys(this.params).length !== 0 || this.filters) {
        if (this.params.id) {
            url.searchParams.append('id', this.params.id)
        }
        if (this.params.search_word) {
          url.searchParams.append('search_word', this.params.search_word)
        }
        if (this.params.island) {
          url.searchParams.append('island', this.params.island)
        }
        if (this.filters.sort_by) {
            url.searchParams.append('sort_by', this.filters.sort_by)
        }
        if (this.filters.genre.length > 0) {
          url.searchParams.append('genre', this.filters.genre)
        }
        if (this.filters.area) {
          url.searchParams.append('area', this.filters.area)
        }
        window.location.href = url
      }
    },
    setParam() {
      if (this.params.sort_by) {
          this.filters.sort_by = this.params.sort_by
      }
      if (this.params.genre) {
        this.filters.genre = this.params.genre.split(',')
      }
      if (this.params.area) {
        this.filters.area = this.params.area
      }
      this.filtersComparison = Object.assign({}, this.filters)
    }
  }
}
</script>
